export const DEFAULT_LANGUAGE = "ja";
export const FALLBACK_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = ["ja", "en"];
export const MILE = 1852.0;

// キーコード
export const KEY_CODE = {
  ESC: 27,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
};

// mixinにあるが、dataで使えないのでconstにも定義
export const NAVIGATIONS_CATEGORY = {
  MARITIME_TRAFFIC_REGULATIONS_ROUTE: 1,
  PORT_TRAFFIC_REGULATIONS_ROUTE: 2,
  LIGHTHOUSE: 3,
  LIGHT_BUOY: 4,
  LIGHT_BEACON: 5,
  OTHER: 6,
};

export const RADAR_GRID_CATEGORY = {
  WAKE_FORECAST: 1,
};

export const VESSEL_CATEGORY = {
  TANKER: 1,
  CARGO: 2,
  TUGBOAT: 3,
  CRUISE: 4,
  FISHING: 5,
  PLEASURE: 7,
  COMPANY: 6,
  JET_SKI: 8,
  WORK: 10,
  SAILBOAT: 11,
  BARGE: 12,
  OTHER: 9,
  properties: {
    1: {
      id: "1",
      name: "tanker",
      name_ja: "タンカー船",
      color: "#EE604C",
      class: "vessel-tanker",
      sort: 1,
      icon: "TankerActive.png",
    },
    2: {
      id: "2",
      name: "cargo",
      name_ja: "貨物船",
      color: "#F3A841",
      class: "vessel-cargo",
      sort: 2,
      icon: "CargoActive.png",
    },
    3: {
      id: "3",
      name: "tugboat",
      name_ja: "タグボート",
      color: "#8DC658",
      class: "vessel-tug",
      sort: 3,
      icon: "TugActive.png",
    },
    4: {
      id: "4",
      name: "cruise",
      name_ja: "旅客船",
      color: "#F0EFEF",
      class: "vessel-cruise",
      sort: 4,
      icon: "PassengerActive.png",
    },
    5: {
      id: "5",
      name: "fishing",
      name_ja: "漁船",
      color: "#2C71B6",
      class: "vessel-fishing",
      sort: 5,
      icon: "FishingActive.png",
    },
    7: {
      id: "7",
      name: "pleasure",
      name_ja: "プレジャーボート",
      color: "#50B0A0",
      class: "vessel-pleasure",
      sort: 7,
      icon: "PleasureBoatActive.png",
    },
    8: {
      id: "8",
      name: "jet_ski",
      name_ja: "水上バイク",
      color: "#FBED56",
      class: "vessel-jet_ski",
      sort: 8,
      icon: "BikeActive.png",
    },
    9: {
      id: "9",
      name: "other",
      name_ja: "その他",
      color: "#C4B28C",
      class: "vessel-other",
      sort: 9,
      icon: "OtherActive.png",
    },
    10: {
      id: "10",
      name: "work",
      name_ja: "作業船",
      color: "#A561D6",
      class: "vessel-work",
      sort: 10,
      icon: "WorkActive.png",
    },
    11: {
      id: "11",
      name: "sailboat",
      name_ja: "ヨット",
      color: "#FF7AAB",
      class: "vessel-sailboat",
      sort: 11,
      icon: "SailboatActive.png",
    },
    12: {
      id: "12",
      name: "barge",
      name_ja: "バージ",
      color: "#A8A7A7",
      class: "vessel-barge",
      sort: 12,
      icon: "BargeActive.png",
    },
  },
};
export const VESSEL_STATUS_OF_VESSELS = {
  SUSPEND: 0,
  STEERING: 1,
  REPAIRING: 2,
  properties: {
    0: { label: "停止中", color: "danger" },
    1: { label: "操船中", color: "success" },
    2: { label: "メンテナンス中", color: "warning" },
  },
};
// 作業船ステータス
export const EQUIPMENT_VESSEL_STATUS = {
  UNDER_WAY_USING_ENGINE: 1,
  UNDER_WAY_INPUT: 2,
  COMPLETE_INPUT: 3,
  properties: {
    1: { label: "航行中" },
    2: { label: "投入中" },
    3: { label: "投入完了" },
  },
};
export const FIRESOTRAGE_URL = [process.env.VUE_APP_FIRESOTRAGE_URL];
export const NAVIGATION_STATUS = {
  UNDER_WAY_USING_ENGINE: 0,
  AT_ANCHOR: 1,
  NOT_UNDER_COMMAND: 2,
  RESTRICTED_MANEUVERABILITY: 3,
  CONSTRAINED_BY_HER_DRAUGHT: 4,
  MOORED: 5,
  AGROUND: 6,
  ENGAGED_IN_FISHING: 7,
  UNDER_WAY_SAILING: 8,
  RESERVED9: 9,
  RESERVED10: 10,
  TOWING: 11,
  PUSHING: 12,
  RESERVED13: 13,
  SART: 14,
  NOT_AVAILABLE: 15,
  NOT_IN_OPARATION: 1000,
  properties: {
    0: { id: "0", name: "underWayUsingEngine", name_ja: "航行中" },
    1: { id: "1", name: "atAnchor", name_ja: "錨泊中" },
    2: { id: "2", name: "notUnderCommand", name_ja: "運転不自由船" },
    3: {
      id: "3",
      name: "restrictedManeuverability",
      name_ja: "操縦性能制限船",
    },
    4: { id: "4", name: "constrainedByHerDraught", name_ja: "喫水制限船" },
    5: { id: "5", name: "moored", name_ja: "係船中" },
    6: { id: "6", name: 'aground"', name_ja: "座礁状態" },
    7: { id: "7", name: "engagedInFishing", name_ja: "漁労中" },
    8: { id: "8", name: "underWaySailing", name_ja: "帆走中" },
    9: { id: "9", name: "reserved9", name_ja: "-" },
    10: { id: "10", name: "reserved10", name_ja: "-" },
    11: { id: "11", name: "towing", name_ja: "曳航中" },
    12: { id: "12", name: "pushing", name_ja: "曳航中" },
    13: { id: "13", name: "reserved13", name_ja: "-" },
    14: { id: "14", name: "sart", name_ja: "遭難中" },
    15: { id: "15", name: "notAvailable", name_ja: "-" },
    1000: { id: "1000", name: "notInOperation", name_ja: "操船停止中" },
  },
};
export const PICTURE_UPLOAD_MODE = {
  ADD_VESSEL: 1,
  MODIFY_VESSEL: 2,
  DELETE_VESSEL: 3,
};
export const MAP_STYLE_DEFAULT = process.env.VUE_APP_MAPBOX_STYLE_DEFAULT;
export const MAP_STYLE_SATELLITE = process.env.VUE_APP_MAPBOX_STYLE_SATELLITE;
export const MAP_DEFAULT_POSITION = {
  center: [139.86448000000001, 35.54817666666667],
  zoom: 10,
};
export const MAP_DEFAULT_SELECTED_FAVORITE_INDEX = 0;

export const PERMISSION_LEVEL = {
  ALL: 30,
  EDIT: 20,
  OPERATOR: 10,
  NONE: 0,
  properties: {
    30: { label: "編集/削除可能" },
    20: { label: "編集可能" },
    10: { label: "操船者" },
    0: { label: "未登録" },
  },
};

export const PICTURE_TYPE = {
  LICENSE: 1,
  PLOT: 2,
  PROFILE: 3,
  TRANSCEIVER: 4,
  VESSEL: 5,
  VESSEL_DOCUMENT: 6,
};

export const LICENSE_TYPE = {
  SMALL: {
    SECOND: 1,
    SECOND_SPECIAL: 2,
    FIRST: 3,
    FIRST_SPECIAL: 4,
    SPECIAL: 5,
    properties: {
      1: { code: "second", label: "2級", value: 2 },
      2: { code: "second_special", label: "2級+特殊", value: 5 },
      3: { code: "first", label: "1級", value: 1 },
      4: { code: "first_special", label: "1級+特殊", value: 4 },
      5: { code: "special", label: "特殊", value: 3 },
    },
  },
  LARGE_ENGINEERING: {
    SIXTH: 1,
    FIFTH: 2,
    FOURTH: 3,
    THIRD: 4,
    SECOND: 5,
    FIRST: 6,
    properties: {
      1: { code: "sixth", label: "6級", value: 11 },
      2: { code: "fifth", label: "5級", value: 10 },
      3: { code: "fourth", label: "4級", value: 9 },
      4: { code: "third", label: "3級", value: 8 },
      5: { code: "second", label: "2級", value: 7 },
      6: { code: "first", label: "1級", value: 6 },
    },
  },
  LARGE_NAVIGATION: {
    SIXTH: 1,
    FIFTH: 2,
    FOURTH: 3,
    THIRD: 4,
    SECOND: 5,
    FIRST: 6,
    properties: {
      1: { code: "sixth", label: "6級", value: 17 },
      2: { code: "fifth", label: "5級", value: 16 },
      3: { code: "fourth", label: "4級", value: 15 },
      4: { code: "third", label: "3級", value: 14 },
      5: { code: "second", label: "2級", value: 13 },
      6: { code: "first", label: "1級", value: 12 },
    },
  },
};

export const PLOT_PARENT_CATEGORY = {
  CONSTRUCTION: 1,
  RESTRICTION: 2,
  USEFUL: 3,
  ATTENTION: 4,
  EMERGENCY: 5,
  FISHING_GEAR: 6,
  properties: {
    1: {
      id: 1,
      code: "construction",
      label: "工事区域",
      comment: "工事エリアを共有し、期間中の安全を確保しましょう。",
      img: "childCategory/UnderConstruction_w@96x-8",
      child: 1,
    },
    2: {
      id: 2,
      code: "restriction",
      label: "航行制限区域",
      comment:
        "工事に伴う制限エリアを共有し、付近の船舶ルート変更を促しましょう。",
      img: "childCategory/LimitedNavigationArea_w@96x-8",
      child: 2,
    },
    3: {
      id: 3,
      code: "useful",
      label: "お役立ち",
      comment: "",
      img: "",
      child: [],
    },
    4: {
      id: 4,
      code: "attention",
      label: "注意",
      comment: "",
      img: "",
      child: [],
    },
    5: {
      id: 5,
      code: "emergency",
      label: "緊急",
      comment: "",
      img: "",
      child: [],
    },
  },
};

export const PLOT_CHILD_CATEGORY = {
  // 工事区域
  CONSTRUCTION: 1,
  // 航行制限区域
  RESTRICTION: 2,
  // お役立ち
  MARINA: 3,
  GAS_STATION: 4,
  LEISURE: 5,
  // 注意
  DANGER_AREA: 6,
  SHALLOWS: 8,
  FLOATING_MATTER: 9,
  BUOY: 10,
  FISHING_NET: 12,
  PROBLEM: 13,
  // 緊急
  RESCUE: 15,
  ACCIDENT: 16,
  // 漁港
  FISHING_PORT: 18,
  // 船着場
  WHARF: 19,
  // 釣り施設
  FISHING_FACILITY: 20,
  // 港湾
  HARBOR: 21,
  // 漁具設置区域
  properties: {
    1: {
      id: 1,
      code: "construction",
      label: "工事区域",
      parent: PLOT_PARENT_CATEGORY.CONSTRUCTION,
      img: "childCategory/UnderConstruction_w@96x-8",
      icon: "icon_small_under_construction",
    },
    2: {
      id: 2,
      code: "restriction",
      label: "航行制限区域",
      parent: PLOT_PARENT_CATEGORY.RESTRICTION,
      img: "childCategory/LimitedNavigationArea_w@96x-8",
      icon: "icon_small_limited_navigation_area",
    },
    3: {
      id: 3,
      code: "marina",
      label: "マリーナ",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/Marine_w@96x-8",
      icon: "icon_small_marina",
    },
    4: {
      id: 4,
      code: "gas_station",
      label: "給油所",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/GasStation_w@96x-8",
      icon: "icon_small_gas_station",
    },
    5: {
      id: 5,
      code: "leisure",
      label: "レジャースポット",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/LeisureSpot_w@96x-8",
      icon: "icon_small_leisure_spot",
    },
    6: {
      id: 6,
      code: "danger_area",
      label: "危険区域",
      parent: PLOT_PARENT_CATEGORY.ATTENTION,
      img: "childCategory/DangerZone_w@96x-8",
      icon: "icon_small_danger_zone",
    },
    8: {
      id: 8,
      code: "shallows",
      label: "浅瀬",
      parent: PLOT_PARENT_CATEGORY.ATTENTION,
      img: "childCategory/Shallows_w@96x-8",
      icon: "icon_small_shallows",
    },
    9: {
      id: 9,
      code: "floating_matter",
      label: "浮遊物",
      parent: PLOT_PARENT_CATEGORY.ATTENTION,
      img: "childCategory/FloatingMatter_w@96x-8",
      icon: "icon_small_floating_matter",
    },
    10: {
      id: 10,
      code: "buoy",
      label: "ブイ",
      parent: PLOT_PARENT_CATEGORY.ATTENTION,
      img: "childCategory/Buoy_w@96x-8",
      icon: "icon_small_buoy",
    },
    12: {
      id: 12,
      code: "fishing_net",
      label: "網",
      parent: PLOT_PARENT_CATEGORY.ATTENTION,
      img: "childCategory/FishingNet_w@96x-8",
      icon: "icon_small_fishing_net",
    },
    13: {
      id: 13,
      code: "problem",
      label: "地図の問題",
      parent: PLOT_PARENT_CATEGORY.ATTENTION,
      img: "childCategory/MapProblem_w@96x-8",
      icon: "icon_small_map_problem",
    },
    15: {
      id: 15,
      code: "rescue",
      label: "救助中",
      parent: PLOT_PARENT_CATEGORY.EMERGENCY,
      img: "childCategory/UnderRescue_w@96x-8",
      icon: "icon_small_under_rescue",
    },
    16: {
      id: 16,
      code: "accident",
      label: "事故",
      parent: PLOT_PARENT_CATEGORY.EMERGENCY,
      img: "childCategory/AccidentReport_w@96x-8",
      icon: "icon_small_accident_report",
    },
    18: {
      id: 18,
      code: "fishing_port",
      label: "漁港",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/FishingPort_w@96x-8",
      icon: "icon_small_fishing_port",
    },
    19: {
      id: 19,
      code: "wharf",
      label: "船着場",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/Wharf_w@96x-8",
      icon: "icon_small_wharf",
    },
    20: {
      id: 20,
      code: "fishing_facility",
      label: "釣り施設",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/FishingFacility_w@96x-8",
      icon: "icon_small_fishing_facility",
    },
    21: {
      id: 21,
      code: "harbor",
      label: "港湾",
      parent: PLOT_PARENT_CATEGORY.USEFUL,
      img: "childCategory/Harbor_w@96x-8",
      icon: "icon_small_harbor",
    },
  },
};

export const PLOT_POINT_INPUT_FORMAT = {
  BASE_10: 0,
  BASE_60: 1,
  XY: 2,
  properties: {
    0: {
      value: 0,
      text: "十進法度単位",
      placeholder:
        "35.60761645841015,139.85535684519846\n緯度,経度のポイントは改行区切りでも入力可能です。",
    },
    1: {
      value: 1,
      text: "度分秒",
      placeholder:
        "353641.2941,1395139.76913\n緯度,経度のポイントは改行区切りでも入力可能です。",
    },
    2: {
      value: 2,
      text: "平面直角座標",
      placeholder:
        "-112169.318,5170.448\nX,Yのポイントは改行区切りでも入力可能です。",
    },
  },
};

/**
 *  平面直角座標系(日本)
 */
export const PLANE_RECTANGULAR_CS_ZONE_JP = {
  SYS_1: 1,
  SYS_2: 2,
  SYS_3: 3,
  SYS_4: 4,
  SYS_5: 5,
  SYS_6: 6,
  SYS_7: 7,
  SYS_8: 8,
  SYS_9: 9,
  SYS_10: 10,
  SYS_11: 11,
  SYS_12: 12,
  SYS_13: 13,
  SYS_14: 14,
  SYS_15: 15,
  SYS_16: 16,
  SYS_17: 17,
  SYS_18: 18,
  SYS_19: 19,
  properties: {
    1: {
      value: 1,
      text: "1系 330000. 1293000.",
      coordinate: [330000.0, 1293000.0],
    },
    2: {
      value: 2,
      text: "2系 330000. 1310000.",
      coordinate: [330000.0, 1310000.0],
    },
    3: {
      value: 3,
      text: "3系 360000. 1321000.",
      coordinate: [360000.0, 1321000.0],
    },
    4: {
      value: 4,
      text: "4系 330000. 1333000.",
      coordinate: [330000.0, 1333000.0],
    },
    5: {
      value: 5,
      text: "5系 360000. 1342000.",
      coordinate: [360000.0, 1342000.0],
    },
    6: {
      value: 6,
      text: "6系 360000. 1360000.",
      coordinate: [360000.0, 1360000.0],
    },
    7: {
      value: 7,
      text: "7系 360000. 1371000.",
      coordinate: [360000.0, 1371000.0],
    },
    8: {
      value: 8,
      text: "8系 360000. 1383000.",
      coordinate: [360000.0, 1383000.0],
    },
    9: {
      value: 9,
      text: "9系 360000. 1395000.",
      coordinate: [360000.0, 1395000.0],
    },
    10: {
      value: 10,
      text: "10系 400000. 1405000.",
      coordinate: [400000.0, 1405000.0],
    },
    11: {
      value: 11,
      text: "11系 440000. 1401500.",
      coordinate: [440000.0, 1401500.0],
    },
    12: {
      value: 12,
      text: "12系 440000. 1421500.",
      coordinate: [4440000.0, 1421500.0],
    },
    13: {
      value: 13,
      text: "13系 440000. 1441500.",
      coordinate: [440000.0, 1441500.0],
    },
    14: {
      value: 14,
      text: "14系 260000. 1420000.",
      coordinate: [260000.0, 1420000.0],
    },
    15: {
      value: 15,
      text: "15系 260000. 1273000.",
      coordinate: [260000.0, 1273000.0],
    },
    16: {
      value: 16,
      text: "16系 260000. 1240000.",
      coordinate: [260000.0, 1240000.0],
    },
    17: {
      value: 17,
      text: "17系 260000. 1310000.",
      coordinate: [260000.0, 1310000.0],
    },
    18: {
      value: 18,
      text: "18系 200000. 1360000.",
      coordinate: [200000.0, 1360000.0],
    },
    19: {
      value: 19,
      text: "19系 260000. 1540000.",
      coordinate: [260000.0, 1540000.0],
    },
  },
};

export const INVITATION_STATUS = {
  NOT_INVITED: 0,
  INVITED: 1,
  APPROVED: 2,
  properties: {
    0: { label: "未招待" },
    1: { label: "招待中/未承認" },
    2: { label: "承認済" },
  },
};

export const PLOT_TOOL_STEPS = {
  SELECT_CATEGORY: 0,
  PLOT_LIST: 1,
  ADD_DETAIL: 2,
  EDIT_DETAIL: 3,
  DELETE_CONFIRM: 4,
  DELETE_COMPLETE: 5,
  COMPLETE_ADD: 6,
  COMPLETE_EDIT: 7,
  EDIT_FROM_DETAIL_LAYER: 8,
  CLOSE: 9,
};

export const VOYAGE_HISTORY_TOOL_STEPS = {
  LIST_ENTERPRISE: 0,
  LIST_VESSEL: 1,
  LIST_USER: 2,
  MAP_VESSEL: 3,
  MAP_USER: 4,
  DELETE_CONFIRM: 5,
  DELETE_COMPLETE: 6,
};

export const DROPZONE_TYPE = {
  USER_DETAIL: 1,
  USER_LICENSE_SMALL: 2,
  USER_LICENSE_LARGE_NAVIGATION: 3,
  USER_LICENSE_LARGE_ENGINEERING: 4,
  VESSEL_DETAIL: 5,
  VESSEL_DOCUMENT: 6,
  properties: {
    1: {
      className: "dropzone__circle",
      uploadMultiple: false,
      store: "enterprise_user",
      state: "state.user-management",
      rootState: "context.rootState.enterprise_user.user-management",
      this: "this.user-management",
      keyPath: ["pictures"],
      toJS: "state.user-management.toJS()",
    },
    2: {
      className: "dropzone__license",
      uploadMultiple: false,
      store: "enterprise_user",
      state: "state.user-management.license.small",
      rootState:
        "context.rootState.enterprise_user.user-management.license.small",
      this: "this.licenseSmall",
      keyPath: ["license", "small", "pictures"],
      toJS: "state.user-management.toJS().license.small",
    },
    3: {
      className: "dropzone__license",
      uploadMultiple: false,
      store: "enterprise_user",
      state: "state.user-management.license.large_navigation",
      rootState:
        "context.rootState.enterprise_user.user-management.license.large_navigation",
      this: "this.licenseLargeNavigation",
      keyPath: ["license", "large_navigation", "pictures"],
      toJS: "state.user-management.toJS().license.large_navigation",
    },
    4: {
      className: "dropzone__license",
      uploadMultiple: false,
      store: "enterprise_user",
      state: "state.user-management.license.large_engineering",
      rootState:
        "context.rootState.enterprise_user.user-management.license.large_engineering",
      this: "this.licenseLargeEngineering",
      keyPath: ["license", "large_engineering", "pictures"],
      toJS: "state.user-management.toJS().license.large_engineering",
    },
    5: {
      className:
        "dropzone__rectangle_240_180 dropzone__rectangle_240_180__view",
      uploadMultiple: true,
      store: "enterprise_vessel",
      state: "state.vessel",
      rootState: "context.rootState.enterprise_vessel.vessel",
      this: "this.vessel",
      post: "addVesselPicture",
      keyPath: ["pictures"],
      toJS: "state.vessel.toJS()",
    },
    6: {
      className:
        "dropzone__rectangle_240_180 dropzone__rectangle_240_180__view",
      uploadMultiple: false,
      store: "enterprise_vessel",
      state: "state.vessel",
      rootState: "context.rootState.enterprise_vessel.editDocuments",
      this: "this.item",
      keyPath: ["pictures"],
      toJS: "state.vessel.toJS()",
    },
  },
};

export const PLOT_POINT_ADD_METHOD = {
  CLICK: 0,
  TEXT: 1,
};

export const REPORT_TYPE = {
  VESSEL: 1,
  PLOT: 2,
  CHART: 3,
};

export const USER_LICENSE_TYPE = {
  SMALL: 1,
  LARGE_NAVIGATION: 2,
  LARGE_ENGINEERING: 3,
  properties: {
    1: {
      state: "state.user-management.license.small",
      keyPath: ["license", "small"],
      keyPathExpire: ["license", "small", "expiration_date"],
      keyPathType: ["license", "small", "type"],
      title: "小型船舶免許",
    },
    2: {
      state: "state.user-management.license.large_navigation",
      keyPath: ["license", "large_navigation"],
      keyPathExpire: ["license", "large_navigation", "expiration_date"],
      keyPathType: ["license", "large_navigation", "type"],
      title: "海技士（航海）",
    },
    3: {
      state: "state.user-management.license.large_engineering",
      keyPath: ["license", "large_engineering"],
      keyPathExpire: ["license", "large_engineering", "expiration_date"],
      keyPathType: ["license", "large_engineering", "type"],
      title: "海技士（機関）",
    },
  },
};

export const LICENSE_INFO = {
  LICENSE_TYPE: "免許種別",
  SMALL: {
    CERTIFICATE_NUMBER: "免許番号",
    EXPIRATION_DATE: "有効年月日",
  },
  LARGE_NAVIGATION: {
    CERTIFICATE_NUMBER: "海技免状番号",
    EXPIRATION_DATE: "免状有効期間満了日",
  },
  LARGE_ENGINEERING: {
    CERTIFICATE_NUMBER: "海技免状番号",
    EXPIRATION_DATE: "免状有効期間満了日",
  },
};

export const PERMANENT_DOMICILE = {
  /*
   * 日本
   */
  HOKKAIDO: 1,
  AOMORI: 2,
  IWATE: 3,
  MIYAGI: 4,
  AKITA: 5,
  YAMAGATA: 6,
  FUKUSHIMA: 7,
  IBARAKI: 8,
  TOCHIGI: 9,
  GUNMA: 10,
  SAITAMA: 11,
  CHIBA: 12,
  TOKYO: 13,
  KANAGAWA: 14,
  NIIGATA: 15,
  TOYAMA: 16,
  ISHIKAWA: 17,
  FUKUI: 18,
  YAMANASHI: 19,
  NAGANO: 20,
  GIFU: 21,
  SHIZUOKA: 22,
  AICHI: 23,
  MIE: 24,
  SHIGA: 25,
  KYOTO: 26,
  OSAKA: 27,
  HYOGO: 28,
  NARA: 29,
  WAKAYAMA: 30,
  TOTTORI: 31,
  SHIMANE: 32,
  OKAYAMA: 33,
  HIROSHIMA: 34,
  YAMAGUCHI: 35,
  TOKUSHIMA: 36,
  KAGAWA: 37,
  EHIME: 38,
  KOCHI: 39,
  FUKUOKA: 40,
  SAGA: 41,
  NAGASAKI: 42,
  KUMAMOTO: 43,
  OITA: 44,
  MIYAZAKI: 45,
  KAGOSHIMA: 46,
  OKINAWA: 47,
  properties: {
    1: { country: "JAPAN", domicile: "北海道" },
    2: { country: "JAPAN", domicile: "青森県" },
    3: { country: "JAPAN", domicile: "岩手県" },
    4: { country: "JAPAN", domicile: "宮城県" },
    5: { country: "JAPAN", domicile: "秋田県" },
    6: { country: "JAPAN", domicile: "山形県" },
    7: { country: "JAPAN", domicile: "福島県" },
    8: { country: "JAPAN", domicile: "茨城県" },
    9: { country: "JAPAN", domicile: "栃木県" },
    10: { country: "JAPAN", domicile: "群馬県" },
    11: { country: "JAPAN", domicile: "埼玉県" },
    12: { country: "JAPAN", domicile: "千葉県" },
    13: { country: "JAPAN", domicile: "東京都" },
    14: { country: "JAPAN", domicile: "神奈川県" },
    15: { country: "JAPAN", domicile: "新潟県" },
    16: { country: "JAPAN", domicile: "富山県" },
    17: { country: "JAPAN", domicile: "石川県" },
    18: { country: "JAPAN", domicile: "福井県" },
    19: { country: "JAPAN", domicile: "山梨県" },
    20: { country: "JAPAN", domicile: "長野県" },
    21: { country: "JAPAN", domicile: "岐阜県" },
    22: { country: "JAPAN", domicile: "静岡県" },
    23: { country: "JAPAN", domicile: "愛知県" },
    24: { country: "JAPAN", domicile: "三重県" },
    25: { country: "JAPAN", domicile: "滋賀県" },
    26: { country: "JAPAN", domicile: "京都府" },
    27: { country: "JAPAN", domicile: "大阪府" },
    28: { country: "JAPAN", domicile: "兵庫県" },
    29: { country: "JAPAN", domicile: "奈良県" },
    30: { country: "JAPAN", domicile: "和歌山県" },
    31: { country: "JAPAN", domicile: "鳥取県" },
    32: { country: "JAPAN", domicile: "島根県" },
    33: { country: "JAPAN", domicile: "岡山県" },
    34: { country: "JAPAN", domicile: "広島県" },
    35: { country: "JAPAN", domicile: "山口県" },
    36: { country: "JAPAN", domicile: "徳島県" },
    37: { country: "JAPAN", domicile: "香川県" },
    38: { country: "JAPAN", domicile: "愛媛県" },
    39: { country: "JAPAN", domicile: "高知県" },
    40: { country: "JAPAN", domicile: "福岡県" },
    41: { country: "JAPAN", domicile: "佐賀県" },
    42: { country: "JAPAN", domicile: "長崎県" },
    43: { country: "JAPAN", domicile: "熊本県" },
    44: { country: "JAPAN", domicile: "大分県" },
    45: { country: "JAPAN", domicile: "宮崎県" },
    46: { country: "JAPAN", domicile: "鹿児島県" },
    47: { country: "JAPAN", domicile: "沖縄県" },
  },
};

export const MANAGEMENT_TYPE = {
  VESSEL: 1,
  USER: 2,
};

export const ERA_JA = {
  HEISEI: 1,
  REIWA: 2,
  properties: {
    1: { label: "平成", year: 1988 },
    2: { label: "令和", year: 2018 },
  },
};

export const LICENSE_NOTIFICATION = {
  THREE_MONTH_AGO: 90,
};

export const VESSEL_LAYER_TYPE = {
  TEXT: 0,
  SYMBOL: 1,
  POLYGON: 2,
  VECTOR_LINE: 3,
  WAKE_LINE: 4,
};

export const VALIDATION_ERROR = {
  USER_NAME: 1,
  USER_NAME_EN: 2,
  LICENSE_TYPE: 3,
  LICENSE_PICTURE: 4,
  LICENSE_EXPIRATION: 5,
  VESSEL_NAME: 6,
  VESSEL_NAME_EN: 7,
  DOCUMENT_NAME: 8,
  DOCUMENT_PICTURE: 9,
  PHONE_NUMBER: 10,
  properties: {
    1: { message: "名前は入力必須です。", target: "name" },
    2: { message: "NAMEは入力必須です。", target: "nameEn" },
    3: { message: "種別は選択必須です。", target: "licenseType" },
    4: { message: "画像の設定は必須です。", target: "licensePicture" },
    5: { message: "有効年月日は選択必須です。", target: "licenseExpiration" },
    6: { message: "船舶名は入力必須です。", target: "nameJa" },
    7: { message: "SHIP NAMEは入力必須です。", target: "name" },
    8: { message: "書類名は入力必須です。", target: "documentName" },
    9: { message: "画像の設定は必須です。", target: "documentPicture" },
    10: { message: "電話番号を入力してください。", target: "phoneNumber" },
  },
};

export const CAMERA_CATEGORY = {
  ALL: 0,
  VESSEL: 1,
  OTHERS: 99,
};

export const CAMERA_MOVIE_TYPE = {
  CAMERA: 1,
  RADAR: 2,
  HYKECAM: 3,
  HLS_CAMERA: 4,
  HLS_RADAR: 5,
  SAFIE: 6,
};

export const CAMERA_MODEL = {
  HV_PTZ500: 1,
  WV_S6530: 2,
  HV_PTZ501: 4,
  OTHERS: 99,
  properties: {
    1: { model: "HV-PTZ500", smallMove: 0.5, largeMove: 2.0, zoomMove: 1.0 },
    2: { model: "WV-S6530", smallMove: 0.5, largeMove: 2.0, zoomMove: 2.0 },
    4: { model: "HV-PTZ501", smallMove: 0.75, largeMove: 1.5, zoomMove: 0.75 },
    99: { model: null, smallMove: 0.5, largeMove: 2.0, zoomMove: 2.0 },
  },
};

export const GROUP_COLOR_PALETTE = [
  {
    normal: "#A93870",
    deep: "#433548",
  },
  {
    normal: "#F23278",
    deep: "#483C4B",
  },
  {
    normal: "#E878A0",
    deep: "#5C4659",
  },
  {
    normal: "#8A93A6",
    deep: "#3C444F",
  },
  {
    normal: "#FE9000",
    deep: "#504536",
  },
  {
    normal: "#0897B4",
    deep: "#264958",
  },
  {
    normal: "#0080FF",
    deep: "#264160",
  },
  {
    normal: "#21B58B",
    deep: "#2B4F50",
  },
  {
    normal: "#7D7ABF",
    deep: "#32384D",
  },
  {
    normal: "#A503D1",
    deep: "#3E2E55",
  },
  {
    normal: "#008F8C",
    deep: "#27424C",
  },
  {
    normal: "#0BB908",
    deep: "#2D3F3D",
  },
  {
    normal: "#B3B700",
    deep: "#3D4440",
  },
  {
    normal: "#F2CB05",
    deep: "#41453B",
  },
  {
    normal: "#D764D9",
    deep: "#4A3E5B",
  },
  {
    normal: "#32CDD7",
    deep: "#334B58",
  },
  {
    normal: "#9DA2EC",
    deep: "#3D4559",
  },
  {
    normal: "#BF9788",
    deep: "#45474D",
  },
  {
    normal: "#F25D50",
    deep: "#4D3C44",
  },
  {
    normal: "#BE92D0",
    deep: "#444458",
  },
];

export const FAVORITE_KEY = {
  FAVORITE_FIRST: "0",
  FAVORITE_SECOND: "1",
  FAVORITE_THIRD: "2",
};

// アンカー船のデータソース
export const ANCHOR_VESSEL_DATA_SOURCE = {
  AISEA: {
    id: 1,
    name: "Aisea投錨管理",
  },
  KEISOKU: {
    id: 2,
    name: "投錨位置管理システム",
  },
};

// 仮設桟橋(Port Master C)
export const VEHICLES_MASTER = [
  {
    id: 1,
    label: "1号車",
  },
  {
    id: 2,
    label: "2号車",
  },
  {
    id: 3,
    label: "3号車",
  },
];

export const VEHICLES_STATUS = {
  NOT_ORDERED: 1,
  ORDERING: 2,
  ORDERED: 3,
};

export const BOARDSIDE_TYPE_MASTERLIST = [
  {
    id: 1,
    label: "左",
    isAddCircleToLabel: false,
    saveValue: "左舷",
  },
  {
    id: 2,
    label: "右",
    isAddCircleToLabel: false,
    saveValue: "右舷",
  },
  {
    id: 3,
    label: "左",
    isAddCircleToLabel: true,
    saveValue: "廻左舷",
  },
  {
    id: 4,
    label: "右",
    isAddCircleToLabel: true,
    saveValue: "廻右舷",
  },
  {
    id: 5,
    label: "？",
    isAddCircleToLabel: false,
    saveValue: "？",
  },
];

export const COL_NAME = [
  /*
   * columnKey:  カラムのキー
   * label:      カラム名(noのみ)
   * name:       カラム名
   * sort:       並び順
   * width:      表示横幅
   * sortable:   ソート可能か否か
   * editable:   列の編集ができるか否か
   * filterable: 行フィルターができるか否か
   * color:      入出港予定表で表示するときの色
   * displayType 入出港予定表でどのように表示するかprogress, HH:mm, MM/DD:HH:mm,
   */
  {
    columnKey: "trash",
    label: "削除",
    name: "",
    sort: -1,
    width: 40,
    minWidth: 40,
    sortable: false,
    editable: true,
    filterable: false,
    displayType: "",
  },
  {
    columnKey: "vessel_id",
    label: "船舶ID",
    name: "",
    sort: 0,
    width: 0,
    sortable: false,
    editable: false,
    filterable: false,
    displayType: "",
  },
  {
    columnKey: "sort_order",
    label: "並び順",
    name: "",
    sort: 1,
    width: 40,
    minWidth: 40,
    sortable: false,
    editable: false,
    filterable: false,
    displayType: "",
  },
  {
    columnKey: "highlight",
    name: "ハイライト",
    sort: 2,
    width: 40,
    minWidth: 40,
    sortable: false,
    editable: false,
    filterable: false,
    color: {},
    displayType: "highlight",
  },
  {
    columnKey: "progress",
    name: "進捗",
    sort: 3,
    width: 120,
    minWidth: 120,
    sortable: true,
    editable: true,
    filterable: false,
    color: {
      1: "#CB4B4F", // 開始前
      2: "#2E87B9", // 進行中
      3: "#4F4F4F", // 終了
      4: "#1C2833", // 中止 suspend
    },
    displayType: "progress",
  },
  {
    columnKey: "order_time",
    name: "オーダー時刻",
    sort: 4,
    width: 110,
    minWidth: 110,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "HH:mm",
  },
  {
    columnKey: "name",
    name: "船舶名",
    sort: 5,
    width: 200,
    minWidth: 0,
    sortable: true,
    editable: false,
    filterable: false,
    displayType: "plain-text",
  },
  /*
   * 表示項目からなくなっているため、コメントアウト。削除可と確認できたときに削除
  {
    columnKey: "type",
    name: "船種",
    sort: 6,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: false,
    filterable: false,
    displayType: "plain-text",
  },
  */
  {
    columnKey: "loading_weight",
    name: "載貨重量",
    sort: 7,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-number",
  },
  {
    columnKey: "boarding_number",
    name: "乗船台数",
    sort: 8,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-number",
  },
  {
    columnKey: "company_name",
    name: "調達会社名",
    sort: 9,
    width: 140,
    minWidth: 140,
    sortable: true,
    editable: false,
    filterable: false,
    displayType: "plain-text",
  },
  {
    columnKey: "from_anchorage_time",
    name: "着岸",
    sort: 10,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "HH:mm",
  },
  {
    columnKey: "to_anchorage_time",
    name: "離岸",
    sort: 11,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "HH:mm",
  },
  {
    columnKey: "island_id",
    name: "島",
    sort: 12,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: true,
    displayType: "masterMap",
    filterKey: "port_id", // フィルタに使用する、taskのプロパティ名
  },
  {
    columnKey: "port_id",
    name: "港",
    sort: 13,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "masterMap",
  },
  {
    columnKey: "quay_id",
    name: "岸壁",
    sort: 14,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "masterMap",
  },
  {
    columnKey: "berth_id",
    name: "バース",
    sort: 15,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "masterMap",
  },
  {
    columnKey: "from_date",
    name: "出港",
    sort: 16,
    width: 150,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "HH:mm",
  },
  {
    columnKey: "to_date",
    name: "到着",
    sort: 17,
    width: 150,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "HH:mm",
  },
  {
    columnKey: "head_count",
    name: "作業人数",
    sort: 19,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-number",
  },
  {
    columnKey: "required_note",
    name: "備考",
    sort: 20,
    width: 250,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-text",
  },
  {
    columnKey: "cautionary_note",
    name: "注意事項",
    sort: 21,
    width: 250,
    minWidth: 0,
    sortable: true,
    editable: false,
    filterable: false,
    displayType: "plain-text",
  },
  {
    columnKey: "team_leader",
    name: "作業班長",
    sort: 22,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-text",
  },
  {
    columnKey: "vehicles",
    name: "作業車両",
    sort: 23,
    width: 300,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "vehicles",
  },
  {
    columnKey: "flag",
    name: "旗",
    sort: 24,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-text",
  },
  {
    columnKey: "bit",
    name: "ビット",
    sort: 25,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "bit",
  },
  {
    columnKey: "boardside_type",
    name: "着舷",
    sort: 26,
    width: 100,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "boardside_type",
  },
  {
    columnKey: "destination_name",
    name: "目的地",
    sort: 26,
    width: 250,
    minWidth: 0,
    sortable: true,
    editable: true,
    filterable: false,
    displayType: "plain-text",
  },
];

export const VESSEL_MASTER_COL_NAME = [
  {
    displayName: "船舶ID",
    inputType: "string",
    key: "id",
    show: false,
    editable: false,
  },
  {
    displayName: "船舶名",
    inputType: "string",
    key: "name",
    show: true,
    editable: false,
  },
  {
    displayName: "船種",
    inputType: "string",
    key: "type",
    show: false, // 削除で可と確認が取れるまで、非表示設定で対応しています。
    editable: false,
  },
  {
    displayName: "載貨重量",
    inputType: "number",
    key: "loading_weight",
    show: true,
    editable: false,
  },
  {
    displayName: "乗船台数",
    inputType: "number",
    key: "boarding_number",
    show: true,
    editable: false,
  },
  {
    displayName: "調達会社名",
    inputType: "string",
    key: "company_name",
    show: true,
    editable: true,
  },
  {
    displayName: "作業人数",
    inputType: "number",
    key: "head_count",
    show: true,
    editable: true,
  },
  {
    displayName: "備考",
    inputType: "textArea",
    key: "required_note",
    show: true,
    editable: true,
  },
  {
    displayName: "注意事項",
    inputType: "textArea",
    key: "cautionary_note",
    show: true,
    editable: true,
  },
  {
    displayName: "登録日時",
    inputType: "time",
    key: "created_at",
    show: true,
    editable: false,
  },
  {
    displayName: "更新日時",
    inputType: "time",
    key: "updated_at",
    show: true,
    editable: false,
  },
];
export const GKMG_AUTH_MASTER = {
  read: {
    PortMenu: {
      edit: false,
      uploadCsv: false,
      displayName: "Viewer",
    },
    destinationWorkList: {
      edit: false,
    },
    dailyReport: {
      download: false,
    },
  },
  grant: {
    PortMenu: {
      edit: true,
      uploadCsv: true,
      displayName: "Admin",
    },
    destinationWorkList: {
      edit: true,
    },
    dailyReport: {
      download: true,
    },
  },
};
